<template>
	<div class="mobiscroll-input-search">
		<label v-if="label" :for="inputID">{{ label }}</label>

		<b-input-group label="producto">
			<b-input :id="inputID" v-model="workingData.text" @keyup="triggerManualUpdate()"
				@focus="toggleSingleMobiscroll" />
			<b-input-group-append>
				<b-button variant="info" @click="toggleSingleMobiscroll" :id="idButtonMobiscrollTrigger">
					<i class="fa fa-search"></i>
				</b-button>
			</b-input-group-append>
		</b-input-group>

		<div style="display: none">
			<div :id="mobiscrollIDHolder"></div>
		</div>

	</div>
</template>

<script>
import mobiscroll from "@mobiscroll/javascript";
import axios from "axios";
import _ from "lodash";

const emptyWorkingData = {
	value: null,
	text: null,
	item: null
};

export default {
	name: 'mobiscrollInputSearch',
	props: {
		keyValue: { type: String, default: 'id_pk' },
		keyText: { type: String, default: 'value' },
		value: {
			type: [Object, String],
			default: () => {
				return {
					value: null,
					id: null,
					item: null
				}
			}
		},
		label: {
			type: String
		},
		uri: {
			type: String,
			default: ""
		}
	},
	data: () => {
		return {
			mobi: null,
			idButtonMobiscrollTrigger: null,
			mobiscrollIDHolder: null,
			inputID: null,
			workingData: _.clone(emptyWorkingData)
		};
	},
	computed: {
		computedURI() {
			return axios.defaults.baseURL + "/" + this.uri + "/";
		}
	},
	methods: {
		clean(){
			this.workingData = _.clone(emptyWorkingData);
			this.mobi.clear(null, true)
		},
		triggerManualUpdate() {
			this.workingData.value = null;
			this.workingData.item = {};
			this.$emit("input", this.workingData);
		},
		toggleSingleMobiscroll() {
			// We pass the ID of the button that we want to return focus to
			// when the modal has hidden
			this.mobi.show();
		},
		createIDs() {
			this.mobiscrollIDHolder = _.uniqueId("mobiscroll-id-holder-");
			this.idButtonMobiscrollTrigger = _.uniqueId("mobiscroll-button-trigger-");
			this.inputID = _.uniqueId("mobiscroll-input-");
		},
		setSelectedValue(value) {
			let found = _.find(this.fullData, (item) => { return ((value) + '') == (item.value + '')})
			// console.log('setSelectedValue', value, found, this.workingData, this.fullData)
			this.workingData = _.cloneDeep(found);
			this.$emit("input", this.workingData);
			this.$emit('change', this.workingData)
			// this.$emit("select", this.workingData);
		},
		loadUpMobiscroll() {
			this.mobi = mobiscroll.select("#" + this.mobiscrollIDHolder, {
				display: "bubble",
				anchor: "#" + this.idButtonMobiscrollTrigger,
				placeholder: "Busca",
				fullData: [],
				filter: true,
				onSet: (a, b) => {
					this.setSelectedValue(b.getVal());
				},
				data: {
					remoteFilter: true,
					url: this.computedURI,
					type: "json",
					processResponse: response => {
						this.fullData = [];
						if (response.status && response.data) {
							this.fullData = _.map(response.data.rows, item => {
								let text = item[this.keyText],
									value = item[this.keyValue];
								return {
									value,
									text,
									html: `<p>${text}</p>`,
									item: _.clone(item)
								};
							});
						} else {
							this.fullData = [
								{
									value: null,
									text: "Nada encontrado",
									html: "<p>Nada encontrado</p>",
									item: {}
								}
							];
						}
						return this.fullData;
					}
				}
			});
		}
	},
	beforeMount() {
		this.createIDs();
	},
	mounted() {
		this.loadUpMobiscroll();
		if(this.value)
			this.workingData = _.clone(this.value)
	}
};
</script>